<template>
  <div id="app">
    <transition name="overflow-fade">
      <div
        v-if="$root.ready && overflow"
        class="ready-overflow"
        @click="openWebsite()"
      >
        <div class="text-center w-100">
          <div class="title">Undangan {{ title }}</div>
          <span>from</span>
          <div class="mb-5 name">
            {{ wedding.man.surname }} & {{ wedding.woman.surname }}
          </div>

          <button
            class="text-uppercase btn btn-outline-primary"
            @click="openWebsite()"
          >
            Buka Undangan
          </button>
        </div>
      </div>
    </transition>

    <AGWAudio
      ref="audio"
      :file="music.file"
      :loop="music.loop"
      :autoplay="music.autoplay"
    />
    <AGWHero
      overlay
      :background="backgrounds"
      ref="hero"
      parallax
      target="#intro"
    />

    <div
      class="bg-white agw-content"
      :style="{ 'margin-top': `${$root.hero.height}px` }"
    >
      <AGWIntro id="intro" />

      <div class="pad-y-60">
        <AGWPawiwahan id="pawiwahan" />
        <AGWMepandes id="mepandes" class="mar-top-60" :mepandes="mepandes" />
      </div>

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class="pad-y-60" />

      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3947.2103120314155!2d115.17967321478199!3d-8.380963293971995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xdb971b5b818ccaec!2zOMKwMjInNTEuNSJTIDExNcKwMTAnNTQuNyJF!5e0!3m2!1sen!2sid!4v1671530588679!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//-8.3809633,115.1818619/@-8.3809633,115.1796732,17z/data=!4m2!4m1!3e0?hl=en"
        :location="location"
        :time="time"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <Himbauan />
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <div :style="{ height: `${$root.dividerHeight}px` }"></div>

    <Footer ref="footer" />

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height" />
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
import Audio from "@/assets/audio/soundtrack.mp3";

import AGWHero from "@/components/Hero";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Himbauan from "@/components/Himbauan.vue";
import Attendance from "@/components/Attendance";
import Footer from "@/components/Footer/Sabali.vue";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance,
    Himbauan,
    Footer
  },
  data() {
    return {
      title: "Pawiwahan",
      backgrounds: [
        "https://ik.imagekit.io/c3remonyku/togar-ayuade/SA-07198.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1671527052309",
        "https://ik.imagekit.io/c3remonyku/togar-ayuade/SA-07094.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1671527049425",
        "https://ik.imagekit.io/c3remonyku/togar-ayuade/SA-07236.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1671527052764"
      ],
      bgActive: 0,
      dividerHeight: 0,
      overflow: true,
      wedding: {
        man: {
          name: "Gede Togar Pangestu",
          surname: "Togar",
          parents: "Juergen Heinrich & Dra. Putu Indri Artini Arta",
          description: "Putra pertama",
          address:
            "Jalan Parigata No.4, Lingkungan Tegal Jimbaran, Kuta Selatan",
          photo:
            "https://ik.imagekit.io/c3remonyku/togar-ayuade/SA-07113.jpg?updatedAt=1671527375492&tr=w-696,h-868,fo-custom,cm-extract"
        },
        woman: {
          name: "Gusti Ayu Made Ardaba Dewi",
          surname: "Dewi",
          parents: "I Gusti Made Sumadi Yoga, Sos.S. & Ni Made Partini, Sos.S.",
          address: "Br. Jelantik, Ds.Apuan, Kec. Baturiti, Kab. Tabanan",
          description: "Putri kedua",
          photo:
            "https://ik.imagekit.io/c3remonyku/togar-ayuade/SA-07106.jpg?updatedAt=1671527359410&tr=w-728,h-910,fo-custom,cm-extract"
        }
      },
      location: "Br. Jelantik, Ds.Apuan, Kec. Baturiti, Kab. Tabanan",
      time: {
        start: this.$moment("2022-12-25 08:00"),
        end: "Selesai"
      },
      mepandes: [],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // if(navigator.serviceWorker) {
    //   navigator.serviceWorker.addEventListener("controllerchange", () => {
    //   if (this.sw.refreshing) return;
    //   // this.sw.refreshing = true;
    //   // window.location.reload();
    // });
    // }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
      this.sw.refreshing = true;
      window.location.reload();
    },
    openWebsite() {
      this.overflow = false;
      document.querySelector("#loading").classList.remove("active");
      if (this.$refs.audio) this.$refs.audio.play();
    }
  }
};
</script>
